/**
 * Suggested Prompts Component
 * 
 * Quick action chips for common questions.
 */

import { Sparkles } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SuggestedPromptsProps {
  prompts: string[];
  onSelect: (prompt: string) => void;
  disabled?: boolean;
  className?: string;
}

export function SuggestedPrompts({ 
  prompts, 
  onSelect, 
  disabled,
  className,
}: SuggestedPromptsProps) {
  if (prompts.length === 0) return null;

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center gap-1.5 text-xs text-text-secondary">
        <Sparkles className="w-3 h-3" />
        <span>Suggested questions</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {prompts.map((prompt, index) => (
          <button
            key={index}
            onClick={() => onSelect(prompt)}
            disabled={disabled}
            className={cn(
              'px-3 py-1.5 text-xs rounded-full',
              'bg-bg-tertiary',
              'text-text-secondary',
              'border border-border-default',
              'hover:bg-bg-tertiary',
              'hover:border-border-default',
              'disabled:opacity-50 disabled:cursor-not-allowed',
              'transition-colors'
            )}
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}
